<template>
  <div>
    <el-upload
      v-if="type == 'border'"
      class="avatar-uploader"
      :style="{
        width: width + 'px',
        height: height + 'px',
      }"
      :action="action"
      :show-file-list="false"
      :on-success="handleAvatarSuccess"
      :before-upload="beforeAvatarUpload"
    >
      <img
        v-if="value && fileType == 'image'"
        :src="value"
        class="avatar"
        :style="{
          width: width + 'px',
          height: height + 'px',
        }"
      />
      <video
        :style="{
          width: width + 'px',
          height: height + 'px',
        }"
        class="avatar"
        v-if="value && fileType == 'video'"
        :src="value"
        autoplay
        muted
      ></video>
      <audio
        v-if="value && fileType == 'audio'"
        :src="value"
        controls
        class="avatar"
        :style="{
          width: width + 'px',
          height: height + 'px',
        }"
      />
      <i
        v-if="!value"
        :style="{
          width: width + 'px',
          height: height + 'px',
          'line-height': height + 'px',
        }"
        class="el-icon-plus avatar-uploader-icon"
      ></i>
    </el-upload>
    <el-upload
      v-else-if="type == 'noBorder'"
      class="avatar-uploaderDefault"
      :style="{
        width: width + 'px',
        height: height + 'px',
      }"
      :action="action"
      :show-file-list="false"
      :on-success="handleAvatarSuccess"
      :before-upload="beforeAvatarUpload"
      style="position: relative"
    >
      <img
        v-if="value && fileType == 'image'"
        :src="value"
        class="avatar"
        :style="{
          width: width + 'px',
          height: height + 'px',
        }"
      />
      <div class="tui-updateUpload" v-if="value" @click.stop="onCLickCouper">
        裁剪
      </div>
      <video
        :style="{
          width: width + 'px',
          height: height + 'px',
        }"
        class="avatar"
        v-if="value && fileType == 'video'"
        :src="value"
        autoplay
        muted
      ></video>
      <audio
        v-if="value && fileType == 'audio'"
        :src="value"
        controls
        class="avatar"
        style="height: 40px"
        :style="{
          width: width + 'px',
          height: height + 'px',
        }"
      />
      <i
        v-if="!value"
        :style="{
          width: width + 'px',
          height: height + 'px',
          'line-height': height + 'px',
        }"
        class="el-icon-plus avatar-uploader-icon"
      ></i>
    </el-upload>
    <el-dialog
      title="图片裁剪"
      :visible.sync="dialogVisible"
      width="50%"
      append-to-body
    >
      <div
        class="cropper"
        style="margin: 0 auto"
        :style="{
          width: width + 'px',
          height: height + 'px',
        }"
      >
        <vueCropper
          ref="cropper"
          :img="option.img"
          :outputSize="option.outputSize"
          :outputType="option.outputType"
          :info="option.info"
          :canScale="option.canScale"
          :autoCrop="option.autoCrop"
          :autoCropWidth="option.autoCropWidth"
          :autoCropHeight="option.autoCropHeight"
          :fixedBox="option.fixedBox"
          :fixed="option.fixed"
          :fixedNumber="option.fixedNumber"
          :canMove="option.canMove"
          :canMoveBox="option.canMoveBox"
          :original="option.original"
          :centerBox="option.centerBox"
          :infoTrue="option.infoTrue"
          :full="option.full"
          :enlarge="option.enlarge"
          :mode="option.mode"
        ></vueCropper>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onClickCropper">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { VueCropper } from "vue-cropper";
import { UploadFile } from "../api/api";
import qs from "qs";

export default {
  components: {
    VueCropper,
  },
  props: {
    action: {
      type: String,
      default: "/api/Img/UploadFile",
    },

    value: {
      type: String,
      default: "",
    },
    flag: {
      default: "",
    },
    type: {
      type: String,
      default: "border",
    },
    width: {
      type: Number,
      default: 72,
    },
    height: {
      type: Number,
      default: 72,
    },
    fileType: {
      type: String,
      default: "image", //video audio
    },
  },
  data() {
    return {
      loadIngFlag: null,
      copyVlaue: "",
      dialogVisible: false,
      option: {
        img: "", // 裁剪图片的地址 url 地址, base64, blob
        outputSize: 1, // 裁剪生成图片的质量
        outputType: "jpeg", // 裁剪生成图片的格式 jpeg, png, webp
        info: true, // 裁剪框的大小信息
        canScale: false, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: this.width, // 默认生成截图框宽度
        autoCropHeight: this.height, // 默认生成截图框高度
        fixedBox: false, // 固定截图框大小 不允许改变
        fixed: false, // 是否开启截图框宽高固定比例
        fixedNumber: [1, 1], // 截图框的宽高比例 [ 宽度 , 高度 ]
        canMove: true, // 上传图片是否可以移动
        canMoveBox: true, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        full: true, // 是否输出原图比例的截图
        enlarge: "1", // 图片根据截图框输出比例倍数
        mode: "contain", // 图片默认渲染方式 contain , cover, 100px, 100% auto
      },
    };
  },
  created() {
    this.copyVlaue = this.value;
  },
  watch: {
    value() {
      this.copyVlaue = this.value;
    },
  },
  methods: {
    // 截图确定
    onClickCropper() {
      this.$refs.cropper.getCropBlob(async (data) => {
        // let form = new FormData();
        // form.append("file", this.base64ToFile(data, "1.png"));
        // let img = window.URL.createObjectURL(data);
        let formData = new FormData();
        formData.append("file", data, "DX.jpg");
        let res = await UploadFile(formData);
        console.log(res);
        if (res.data.success) {
          this.$emit("Success", res.data, this.flag);
          // this.$emit("input", res.data.response);
          this.dialogVisible = false;
        }
        // console.log(res);
      });
    },
    blobToBase64(blob, callback) {
      const fileReader = new FileReader();
      fileReader.onload = (e) => {
        callback(e.target.result);
      };
      fileReader.readAsDataURL(blob);
    },
    // 点击图片裁剪
    onCLickCouper() {
      // this.dialogVisible = true;
      this.option.img = "";
      this.setAvatarBase64(this.value, (base64) => {
        this.$nextTick(() => {
          this.option.img = base64;
          this.dialogVisible = true;
        });
      });
      console.log("点击图片裁剪");
    },
    //解码base64，以file上传给后端
    base64ToFile(urlData, fileName) {
      let arr = urlData.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let bytes = atob(arr[1]); // 解码base64
      let n = bytes.length;
      let ia = new Uint8Array(n);
      while (n--) {
        ia[n] = bytes.charCodeAt(n);
      }
      console.log(mime, ia);
      return new File([ia], fileName, { type: mime });
    },
    // 将网络图片转换成base64格式
    transBase64FromImage(image) {
      let canvas = document.createElement("canvas");
      canvas.width = image.width;
      canvas.height = image.height;
      let ctx = canvas.getContext("2d");
      ctx.drawImage(image, 0, 0, image.width, image.height);
      // 可选其他值 image/jpeg
      return canvas.toDataURL("image/jpeg");
    },
    // 设置需要展示的图片  base64
    setAvatarBase64(src, callback) {
      let _this = this;
      let image = new Image();
      // 处理缓存
      image.src = src + "?v=" + Math.random();
      // 支持跨域图片
      image.crossOrigin = "*";
      image.onload = function () {
        let base64 = _this.transBase64FromImage(image);
        callback && callback(base64);
      };
    },
    handleAvatarSuccess(res) {
      this.$emit("Success", res, this.flag);
      if (res.success) {
        console.log(123);
        this.$emit("input", res.response);
      }

      if (this.loadIngFlag) {
        this.loadIngFlag.close();
      }
    },
    beforeAvatarUpload(file) {
      if (this.fileType == "image") {
        const isJPG = file.type === "image/jpeg";
        const isPNG = file.type === "image/png";
        const isLt2M = file.size / 1024 / 1024 < 20;
        if (!isJPG && !isPNG) {
          this.$message.error("上传图片只能是 JPG 格式!");
        }
        if (!isLt2M) {
          this.$message.error("上传图片大小不能超过 20MB!");
        }
        if (this.loadIngFlag) {
          this.loadIngFlag.close();
        }
        if ((isJPG || isPNG) && isLt2M) {
          this.loadIngFlag = this.$loading({
            lock: true,
            text: "图片上传中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
        }

        return (isJPG || isPNG) && isLt2M;
      } else if (this.fileType == "video") {
        const isVideo = file.type.substr(0, 5) === "video";
        if (isVideo) {
          this.loadIngFlag = this.$loading({
            lock: true,
            text: "视频上传中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
        } else {
          this.$message.error("请上传视频");
        }
        return isVideo;
      } else if (this.fileType == "audio") {
        let typeArr = file.type.split("/");
        if (typeArr[0] == "audio") {
          this.loadIngFlag = this.$loading({
            lock: true,
            text: "音频上传中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          return true;
        } else {
          this.$message.warning("请上传音频文件");
          return false;
        }
      } else {
        return true;
      }
    },
  },
};
</script>

<style scoped>
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 72px;
  height: 72px;
  line-height: 72px;
  text-align: center;
  border: solid 1px #ccc;
}
.avatar {
  object-fit: contain;
}
.avatar-uploaderDefault {
  background: #ededed;
}
.tui-updateUpload {
  width: 100px;
  height: 40px;
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  left: 0;
  bottom: 20px;
  right: 0;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  color: #fff;
}
</style>